import { Inject, NgModule, effect } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LoginComponent } from './login.component';
import { ILoginState, initialSolutionState, ISolutionsState, loginInitialState } from './store/state';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IAlertsState, initialAlertsState } from '../store/alerts/state';
import { appUiAuthInitialState, IAppAuthorizations } from '../authorizations/state';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import { SignInModule } from '@roosevelt/common-ui-lib/sign-in';
import { InputModule } from '@roosevelt/common-ui-lib/input';
import { SelectModule } from '@roosevelt/common-ui-lib/select';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { DialogModule } from '@roosevelt/common-ui-lib/dialog';
import { toSignal } from '@angular/core/rxjs-interop';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    SignInModule,
    ReactiveFormsModule,
    InputModule,
    FormsModule,
    CommonModule,
    DialogModule,
    ButtonModule,
    SelectModule
  ]
})
export class LoginModule {
  constructor(@Inject(DOCUMENT) private readonly document: Document, lux: Lux<{ login: ILoginState, solutionsLogin: ISolutionsState, bmtAlertsState: IAlertsState, appUiAuth: IAppAuthorizations }>) {
    const adminPlan = this.document.location.pathname.split('/')[1];
    const loginState = JSON.parse(sessionStorage.getItem(adminPlan + '-login-state'));
    const bmtAlertsState = JSON.parse(sessionStorage.getItem('bmtAlertsState'));
    const appUiAuthState = JSON.parse(sessionStorage.getItem('app-ui-auth'));
    lux.register('login', loginState || loginInitialState);
    lux.register('solutionsLogin', initialSolutionState);
    lux.register('bmtAlertsState', bmtAlertsState || initialAlertsState);
    lux.register('appUiAuth', appUiAuthState || appUiAuthInitialState);
    const allChanges = toSignal(lux.allChanges(), {
      initialValue: {
        login: loginState || loginInitialState,
        solutionsLogin: initialSolutionState,
        bmtAlertsState: bmtAlertsState || initialAlertsState,
        appUiAuth: appUiAuthState || appUiAuthInitialState
      }
    });
    effect(() => {
      const state = allChanges();
      sessionStorage.setItem(adminPlan + '-login-state', JSON.stringify(state.login));
      sessionStorage.setItem('bmtAlertsState', JSON.stringify(state.bmtAlertsState));
      sessionStorage.setItem('app-ui-auth', JSON.stringify(state.appUiAuth));
    });
  }
}
